module.exports = __webpack_public_path__ + "img/share.409885cf.png";